// **************  开始备课  ****************

// 开始备课获取课程基本信息 actions
export const PREPARE_GET_INFO = 'PREPARE_GET_INFO';
export const PREPARE_SET_INFO = 'PREPARE_SET_INFO';

// 备课编辑课节，不修改知识点 及修改课节名称 mutations
export const PREPARE_MODIFY_SESSION_NAME = 'PREPARE_MODIFY_SESSION_NAME';
export const PREPARE_SET_SESSION_NAME = 'PREPARE_SET_SESSION_NAME';

// 使用讲义替换当前知识点 actions
export const PREPARE_USE_COURSEWARE = 'PREPARE_USE_COURSEWARE';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_prepare.js